module.exports = __webpack_public_path__ + "img/sygnet.876b4503.svg";